exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".checkbox-title[data-v-73ece944]{margin-left:10px;margin-bottom:0;line-height:40px}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/views/ContactForm.vue"],"names":[],"mappings":"AACA,iCACI,iBAAkB,AAClB,gBAAmB,AACnB,gBAAkB,CACrB","file":"ContactForm.vue","sourcesContent":["\n.checkbox-title[data-v-73ece944] {\n    margin-left: 10px;\n    margin-bottom: 0px;\n    line-height: 40px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-73ece944","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/ContactForm.vue
// module id = 2194
// module chunks = 25